import React from "react"
import { Field, FieldProps } from "react-final-form"
import MaskedInput from "react-text-mask"
import styled from "styled-components"
import { Palette } from "theme"

import { DefaultField, DefaultFieldProps } from "components/form/shared/default-field"
import { INPUT_CSS } from "components/form/shared/default-field/styles"
import { transformPhoneNumber } from "components/form/shared/transforms"
import { validatePhoneNumber } from "components/form/shared/validations"

const Input = styled(MaskedInput)<{
  color: keyof Palette
}>`
  color: ${props => props.theme.colors[props.color]};
  font-family: ${props => props.theme.fonts.paragraph};
  line-height: 1.75;
  ${INPUT_CSS}
`

Input.defaultProps = {
  mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
  placeholder: "(___) ___-____",
  type: "tel"
}

export function PhoneNumberInputField(props: FieldProps<string, HTMLInputElement>) {
  return (
    <Field InputComponent={Input} {...props} validate={validatePhoneNumber} parse={transformPhoneNumber}>
      {(inputProps: DefaultFieldProps<string>) => <DefaultField {...inputProps} />}
    </Field>
  )
}
